var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        name: "addusermodal",
        width: _vm.modalWidth,
        minHeight: 200,
        minWidth: 200,
        maxWidth: 1300,
        scrollable: true,
        adaptive: true,
        reset: true,
        height: "auto"
      },
      on: { "before-open": _vm.beforeOpen, "before-close": _vm.beforeClose }
    },
    [
      _c("div", { staticClass: "modal--container" }, [
        _c("div", { staticClass: "d-flex justify-content-end pt-3" }, [
          _c(
            "button",
            {
              staticClass: "close",
              attrs: { type: "button" },
              on: { click: _vm.closeModal }
            },
            [
              _c(
                "span",
                { attrs: { "aria-hidden": "true" } },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: "times", size: "1x" }
                  })
                ],
                1
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "form",
          {
            staticClass: "mt-3",
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.saveEmp.apply(null, arguments)
              }
            }
          },
          [
            _c("div", { staticClass: "row my-2 flex-column flex-md-row" }, [
              _c(
                "div",
                { staticClass: "col-12 col-md-4 form-group edit-modal-item" },
                [
                  _c("label", [_vm._v("First name *")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.employeeDetails.first_name,
                        expression: "employeeDetails.first_name"
                      }
                    ],
                    attrs: {
                      type: "text",
                      required: "",
                      disabled: _vm.disableFields
                    },
                    domProps: { value: _vm.employeeDetails.first_name },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.employeeDetails,
                          "first_name",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12 col-md-4 form-group edit-modal-item" },
                [
                  _c("label", [_vm._v("Last name *")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.employeeDetails.last_name,
                        expression: "employeeDetails.last_name"
                      }
                    ],
                    attrs: {
                      type: "text",
                      required: "",
                      disabled: _vm.disableFields
                    },
                    domProps: { value: _vm.employeeDetails.last_name },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.employeeDetails,
                          "last_name",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12 col-md-4 form-group edit-modal-item" },
                [
                  _c("label", [_vm._v("Email *")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.employeeDetails.email,
                        expression: "employeeDetails.email"
                      }
                    ],
                    attrs: { type: "email", required: "" },
                    domProps: { value: _vm.employeeDetails.email },
                    on: {
                      blur: _vm.checkEmail,
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.employeeDetails,
                          "email",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row flex-column flex-md-row my-2" }, [
              _c(
                "div",
                {
                  class: {
                    "col-12 col-md-4 form-group edit-modal-item low-opacity": true,
                    "full-opacity":
                      _vm.officeTeams && _vm.officeTeams.length > 0
                  }
                },
                [
                  _c("label", [_vm._v("Team *")]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.employeeDetails.team,
                          expression: "employeeDetails.team"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { required: _vm.officeTeams.length > 0 },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.employeeDetails,
                            "team",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    [
                      _c(
                        "option",
                        { attrs: { value: "", selected: "", disabled: "" } },
                        [_vm._v("Select a team")]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.officeTeams, function(team) {
                        return _c(
                          "option",
                          { key: team.id, domProps: { value: team.id } },
                          [_vm._v(_vm._s(team.attributes.name))]
                        )
                      })
                    ],
                    2
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12 col-md-3 form-group edit-modal-item" },
                [
                  _c("label", [_vm._v("Title")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.employeeDetails.designation,
                        expression: "employeeDetails.designation"
                      }
                    ],
                    attrs: { type: "text" },
                    domProps: { value: _vm.employeeDetails.designation },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.employeeDetails,
                          "designation",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row flex-column flex-md-row my-2" }, [
              _c(
                "div",
                { staticClass: "col-12 col-md-4 form-group edit-modal-item" },
                [
                  _c("label", [_vm._v("Reminder 1")]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.employeeDetails.first_reminder,
                          expression: "employeeDetails.first_reminder"
                        }
                      ],
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.employeeDetails,
                            "first_reminder",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    [
                      _c(
                        "option",
                        { attrs: { selected: "", value: "no reminder" } },
                        [_vm._v("No reminder")]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.reminderOptions, function(timeSlot, index) {
                        return _c(
                          "option",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isReminderChosen(timeSlot),
                                expression: "isReminderChosen(timeSlot)"
                              }
                            ],
                            key: index,
                            domProps: { value: timeSlot }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(timeSlot + " minutes") +
                                "\n            "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12 col-md-4 form-group edit-modal-item" },
                [
                  _c("label", [_vm._v("Reminder 2")]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.employeeDetails.second_reminder,
                          expression: "employeeDetails.second_reminder"
                        }
                      ],
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.employeeDetails,
                            "second_reminder",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    [
                      _c(
                        "option",
                        {
                          attrs: { value: "no reminder" },
                          domProps: { selected: true }
                        },
                        [_vm._v("No reminder")]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.reminderOptions, function(timeSlot, index) {
                        return _c(
                          "option",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isReminderChosen(timeSlot),
                                expression: "isReminderChosen(timeSlot)"
                              }
                            ],
                            key: index,
                            domProps: { value: timeSlot }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(timeSlot + " minutes") +
                                "\n            "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12 col-md-4 form-group edit-modal-item" },
                [
                  _c("label", [_vm._v("Reminder 3")]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.employeeDetails.third_reminder,
                          expression: "employeeDetails.third_reminder"
                        }
                      ],
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.employeeDetails,
                            "third_reminder",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    [
                      _c(
                        "option",
                        {
                          attrs: { value: "no reminder" },
                          domProps: { selected: true }
                        },
                        [_vm._v("No reminder")]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.reminderOptions, function(timeSlot, index) {
                        return _c(
                          "option",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isReminderChosen(timeSlot),
                                expression: "isReminderChosen(timeSlot)"
                              }
                            ],
                            key: index,
                            domProps: { value: timeSlot }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(timeSlot + " minutes") +
                                "\n            "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "row mt-2 flex-column flex-md-row align-items-center"
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex flex-column col-12 col-md-4 form-group edit-modal-item"
                  },
                  [
                    _c("label", [_vm._v("Subsidy Type *")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "d-flex align-items-center" }, [
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-center mr-4" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.employeeDetails.subsidy_type,
                                expression: "employeeDetails.subsidy_type"
                              }
                            ],
                            staticClass: "mr-2",
                            attrs: {
                              type: "radio",
                              id: "daily",
                              value: "daily"
                            },
                            domProps: {
                              checked: _vm._q(
                                _vm.employeeDetails.subsidy_type,
                                "daily"
                              )
                            },
                            on: {
                              change: function($event) {
                                return _vm.$set(
                                  _vm.employeeDetails,
                                  "subsidy_type",
                                  "daily"
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "daily" } }, [
                            _vm._v("Daily")
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "d-flex align-items-center" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.employeeDetails.subsidy_type,
                              expression: "employeeDetails.subsidy_type"
                            }
                          ],
                          staticClass: "mr-2",
                          attrs: {
                            type: "radio",
                            id: "weekly",
                            value: "weekly"
                          },
                          domProps: {
                            checked: _vm._q(
                              _vm.employeeDetails.subsidy_type,
                              "weekly"
                            )
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(
                                _vm.employeeDetails,
                                "subsidy_type",
                                "weekly"
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "weekly" } }, [
                          _vm._v("Weekly")
                        ])
                      ])
                    ])
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row mt-2" }, [
              _vm.employeeDetails.subsidy_type == "daily"
                ? _c(
                    "div",
                    { staticClass: "col-12 form-group edit-modal-item" },
                    [
                      _c("label", { staticStyle: { "font-weight": "500" } }, [
                        _vm._v("Daily Subsidy")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex flex-column flex-wrap flex-md-row dailyLimits_container mb-1"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: " col-md-4 dailyLimit_item" },
                            [
                              _c("label", [_vm._v("Monday")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  { name: "clear", rawName: "v-clear" },
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.employeeDetails.daily_subsidy.monday,
                                    expression:
                                      "employeeDetails.daily_subsidy.monday"
                                  }
                                ],
                                attrs: { type: "text" },
                                domProps: {
                                  value:
                                    _vm.employeeDetails.daily_subsidy.monday
                                },
                                on: {
                                  keydown: function($event) {
                                    return _vm.filterKey($event)
                                  },
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.employeeDetails.daily_subsidy,
                                      "monday",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: " col-md-4 dailyLimit_item" },
                            [
                              _c("label", [_vm._v("Tuesday")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  { name: "clear", rawName: "v-clear" },
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.employeeDetails.daily_subsidy.tuesday,
                                    expression:
                                      "employeeDetails.daily_subsidy.tuesday"
                                  }
                                ],
                                attrs: { type: "text" },
                                domProps: {
                                  value:
                                    _vm.employeeDetails.daily_subsidy.tuesday
                                },
                                on: {
                                  keydown: function($event) {
                                    return _vm.filterKey($event)
                                  },
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.employeeDetails.daily_subsidy,
                                      "tuesday",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-md-4 dailyLimit_item form-group"
                            },
                            [
                              _c("label", [_vm._v("Wednesday")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  { name: "clear", rawName: "v-clear" },
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.employeeDetails.daily_subsidy
                                        .wednesday,
                                    expression:
                                      "employeeDetails.daily_subsidy.wednesday"
                                  }
                                ],
                                attrs: { type: "text" },
                                domProps: {
                                  value:
                                    _vm.employeeDetails.daily_subsidy.wednesday
                                },
                                on: {
                                  keydown: function($event) {
                                    return _vm.filterKey($event)
                                  },
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.employeeDetails.daily_subsidy,
                                      "wednesday",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-md-4 dailyLimit_item form-group"
                            },
                            [
                              _c("label", [_vm._v("Thursday")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  { name: "clear", rawName: "v-clear" },
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.employeeDetails.daily_subsidy
                                        .thursday,
                                    expression:
                                      "employeeDetails.daily_subsidy.thursday"
                                  }
                                ],
                                attrs: { type: "text" },
                                domProps: {
                                  value:
                                    _vm.employeeDetails.daily_subsidy.thursday
                                },
                                on: {
                                  keydown: function($event) {
                                    return _vm.filterKey($event)
                                  },
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.employeeDetails.daily_subsidy,
                                      "thursday",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-md-4 dailyLimit_item form-group"
                            },
                            [
                              _c("label", [_vm._v("Friday")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  { name: "clear", rawName: "v-clear" },
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.employeeDetails.daily_subsidy.friday,
                                    expression:
                                      "employeeDetails.daily_subsidy.friday"
                                  }
                                ],
                                attrs: { type: "text" },
                                domProps: {
                                  value:
                                    _vm.employeeDetails.daily_subsidy.friday
                                },
                                on: {
                                  keydown: function($event) {
                                    return _vm.filterKey($event)
                                  },
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.employeeDetails.daily_subsidy,
                                      "friday",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-md-4 dailyLimit_item form-group"
                            },
                            [
                              _c("label", [_vm._v("Saturday")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  { name: "clear", rawName: "v-clear" },
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.employeeDetails.daily_subsidy
                                        .saturday,
                                    expression:
                                      "employeeDetails.daily_subsidy.saturday"
                                  }
                                ],
                                attrs: { type: "text" },
                                domProps: {
                                  value:
                                    _vm.employeeDetails.daily_subsidy.saturday
                                },
                                on: {
                                  keydown: function($event) {
                                    return _vm.filterKey($event)
                                  },
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.employeeDetails.daily_subsidy,
                                      "saturday",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-md-4 dailyLimit_item form-group"
                            },
                            [
                              _c("label", [_vm._v("Sunday")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  { name: "clear", rawName: "v-clear" },
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.employeeDetails.daily_subsidy.sunday,
                                    expression:
                                      "employeeDetails.daily_subsidy.sunday"
                                  }
                                ],
                                attrs: { type: "text" },
                                domProps: {
                                  value:
                                    _vm.employeeDetails.daily_subsidy.sunday
                                },
                                on: {
                                  keydown: function($event) {
                                    return _vm.filterKey($event)
                                  },
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.employeeDetails.daily_subsidy,
                                      "sunday",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]
                          )
                        ]
                      )
                    ]
                  )
                : _c(
                    "div",
                    { staticClass: "col-12 form-group edit-modal-item" },
                    [
                      _c("label", { staticStyle: { "font-weight": "500" } }, [
                        _vm._v("Weekly Subsidy")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "row dailyLimits_container mb-1" },
                        [
                          _c(
                            "div",
                            { staticClass: "col-4 dailyLimit_item form-group" },
                            [
                              _c("label", [_vm._v("Subsidy")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  { name: "clear", rawName: "v-clear" },
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.employeeDetails.subsidy,
                                    expression: "employeeDetails.subsidy"
                                  }
                                ],
                                attrs: { required: "", type: "text" },
                                domProps: {
                                  value: _vm.employeeDetails.subsidy
                                },
                                on: {
                                  keydown: function($event) {
                                    return _vm.filterKey($event)
                                  },
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.employeeDetails,
                                      "subsidy",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]
                          )
                        ]
                      )
                    ]
                  )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mt-1 mb-3" }, [
              _vm.error
                ? _c(
                    "div",
                    {
                      staticClass: "col-12 alert alert-danger alert-dismissible"
                    },
                    [_c("p", [_vm._v(_vm._s(this.error))])]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex flex-column flex-md-row w-100 justify-content-end"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-items-center ml-md-0 ml-3 mb-2 mb-md-0"
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.sendEmail,
                            expression: "sendEmail"
                          }
                        ],
                        staticClass: "mr-2",
                        attrs: { type: "checkbox", id: "cutlery" },
                        domProps: {
                          checked: Array.isArray(_vm.sendEmail)
                            ? _vm._i(_vm.sendEmail, null) > -1
                            : _vm.sendEmail
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.sendEmail,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.sendEmail = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.sendEmail = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.sendEmail = $$c
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        { staticClass: "mb-0", attrs: { for: "cutlery" } },
                        [_vm._v("Send welcome email")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col my-1 my-md-0" }, [
                    _c(
                      "button",
                      {
                        staticClass: "save_btn hover-dark",
                        attrs: { type: "submit" }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.isSoftDeleted ? "Revert" : "Invite") +
                            "\n            "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col my-1 my-md-0" }, [
                    _c(
                      "button",
                      {
                        staticClass: "other_btn hover-gray",
                        attrs: { type: "button" },
                        on: { click: _vm.closeModal }
                      },
                      [_vm._v("\n              Close\n            ")]
                    )
                  ])
                ]
              )
            ])
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-429b9bb4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-429b9bb4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OfficeAdmin/AdminAddUserModal.vue
// module id = null
// module chunks = 